import { Injectable } from '@angular/core';
import { NgbCalendar, NgbDate } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class DateHelperService {

    public static readonly YYYY_MM_DD_DASH_FORMAT = 'yyyy-mm-dd';
    public static readonly YYYY_MM_DD_NO_DASH_FORMAT = 'yyyymmdd';

    constructor(
        private calendar: NgbCalendar
    ) {
    }

    isNgbDateValid(date: NgbDate | null): boolean {
        if (!date) {
            return false;
        }

        // Check if all required properties exist and are numbers
        if (typeof date.year !== 'number' ||
            typeof date.month !== 'number' ||
            typeof date.day !== 'number') {
            return false;
        }

        // Validate ranges
        if (date.year < 1900 || date.year > 9999) {
            return false;
        }

        if (date.month < 1 || date.month > 12) {
            return false;
        }

        // Get the last day of the month
        const lastDayOfMonth = new Date(date.year, date.month, 0).getDate();

        if (date.day < 1 || date.day > lastDayOfMonth) {
            return false;
        }

        return true;
    }

    convertNgbDateToString(date: NgbDate) {
        return '' + date.year + this.twoDigit(date.month) + this.twoDigit(date.day);
    }

    convertFormattedNgbDateToString(date: NgbDate, format: string) {
        return '' + date.year + format + this.twoDigit(date.month) + format + this.twoDigit(date.day);
    }

    convertFormattedDateStringToNgbDate(dateString: string, format: string): NgbDate {
        // Convert date strings in the format to yyyy-mm-dd or yyyymmdd
        if (dateString && format && dateString.length === format.length) {
            if (format === DateHelperService.YYYY_MM_DD_DASH_FORMAT) {
                const year = Number(dateString.substring(0, 4));
                const month = Number(dateString.substring(5, 7));
                const day = Number(dateString.substring(8, 10));
                return new NgbDate(year, month, day);
            } else if (format === DateHelperService.YYYY_MM_DD_NO_DASH_FORMAT) {
                const year = Number(dateString.substring(0, 4));
                const month = Number(dateString.substring(4, 6));
                const day = Number(dateString.substring(6, 8));
                return new NgbDate(year, month, day);
            }
        }
        return this.calendar.getToday();
    }

    convertStringToNgbDate(dateString: string): NgbDate {
        if (dateString && dateString.length === 8) {
            const year = Number(dateString.substring(0, 4));
            const month = Number(dateString.substring(4, 6));
            const day = Number(dateString.substring(6, 8));
            return new NgbDate(year, month, day);
        }
        return this.calendar.getToday();
    }

    private twoDigit(n) {
        return (n < 10 ? '0' : '') + n;
    }

}
